import BottomNav from "@/components/BottomNav/BottomNav";
import NavBar from "@/components/NavBar/NavBar";
import LikedRecipe from "@/ui/Icons/LikedRecipe";
import UploadIcon from "@/ui/Icons/UploadIcon";
import Loader from "@/components/Loaders/Loader";

import HistoryIconBlue from "@/ui/Icons/HistoryIconBlue";
import ShareIcon from "@/ui/Icons/ShareIcon";
import router from "next/router";
import { useUser } from "@/hooks/useUser";
import { useSupabaseClient } from "@supabase/auth-helpers-react";
import { useState, useEffect, use } from "react";

export default function () {
  const user: any = useUser();
  const supabaseClient = useSupabaseClient();
  const [loading, isLoading] = useState(true);
  const [uploadedRecipearr, setUploadedRecipes] = useState<any[]>([]);

  const [arr, setData] = useState<any[]>([]);
  const [likedRecipeArr, setdataa] = useState<any[]>([]);
  const UploadedRecipes = async () => {
    try {
      let { data, error } = await supabaseClient
        .from("recipe")
        .select("*")
        .eq("creatorID", user.email);

      if (error) throw error;
      data = data && data.reverse();

      setUploadedRecipes(data ? data : []);
    } catch (error) {
      console.error("Data fetch failed: ", error);
    }
  };
  const fetchRecipeData = async () => {
    try {
      let { data, error } = await supabaseClient
        .from("recipe_feedback")
        .select("*")
        .eq("user_id", user ? user["id"] : "");

      if (error) throw error;
      data = data && data.reverse();

      if (data) {
        const uniqueData = Array.from(
          data
            .reduce((map, obj) => map.set(obj.recipe_id, obj), new Map())
            .values()
        );
        setdataa(uniqueData);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchData = async () => {
    try {
      let { data, error } = await supabaseClient
        .from("calendar_history")
        .select(
          `*,
          recipe!calendar_history_recipe_id_fkey(
            *,
            servings:serving(
              *,
              ingredients:serving_ingredient(
                *,
                ingredient(
                  *
                )
              )
            )
          )`
        );
      if (error) throw error;

      data = data && data.reverse();
      setData(data ? data : []);
      isLoading(false);
    } catch (error) {
      console.error("Data fetch failed: ", error);
    }
  };

  useEffect(() => {
    if (user) {
      fetchRecipeData();
      fetchData();
      UploadedRecipes();
    }
  }, [user]);
  if (loading) {
    return (
      <div className=" w-full h-screen bg-[#F9F7F7] relative flex flex-col ">
        <div className="flex flex-col items-center pb-10">
          <NavBar heading="Library" />
        </div>
        <div className="flex items-center flex-col top-1/2 absolute w-screen left-1/2 translate-x-[-50%]">
          <Loader />
          <h1>Loading</h1>
        </div>
        <BottomNav />
      </div>
    );
  } else {
    return (
      <>
        <section
          className={
            "bg-[#F9F7F7] h-screen max-w-xl overflow-scroll mx-auto scrollbar-hide"
          }
        >
          <NavBar heading="Library" />
          <div
            onClick={() => {
              router.push(`/library/${user["user_metadata"]["name"]}`);
            }}
            className=" flex flex-col items-center gap-8 mt-5"
          >
            {" "}
            <div className=" h-[100px] w-[88%] lg:w-[80%] rounded-xl  bg-white flex items-center">
              <div
                onClick={() => {
                  router.push(`/library/${user["user_metadata"]["name"]}`);
                }}
                className="w-[80px] h-[80px] rounded-full flex items-center justify-center ml-6 bg-[#c8a4ee]"
              >
                <UploadIcon />
              </div>
              <div className="flex flex-col ml-10">
                <div className=" font-semibold text-lg ">Uploaded Recipes</div>
                <div className=" ">{uploadedRecipearr.length} Recipes</div>
              </div>
            </div>
          </div>
          <div
            onClick={() => {
              router.push("/library/LikedRecipes");
            }}
            className=" flex flex-col items-center gap-8 mt-5"
          >
            {" "}
            <div className=" h-[100px] w-[88%] lg:w-[80%] rounded-xl  bg-white flex items-center">
              <div
                className={`w-[80px] h-[80px] rounded-full flex items-center justify-center ml-6 bg-[#ff85b1]`}
              >
                <LikedRecipe />
              </div>
              <div className="flex flex-col ml-10">
                <div className=" font-semibold text-lg ">Liked Recipes</div>
                <div className=" ">{likedRecipeArr.length} Recipes</div>
              </div>
            </div>
          </div>
          <div
            onClick={() => {
              router.push("/library/calenderHistory");
            }}
            className=" flex flex-col items-center mt-5"
          >
            {" "}
            <div className=" h-[100px] w-[88%] lg:w-[80%] rounded-xl  bg-white flex items-center">
              <div
                className={`w-[80px] h-[80px] rounded-full flex items-center justify-center ml-6 bg-[#85c5ff]`}
              >
                <HistoryIconBlue />
              </div>
              <div className="flex flex-col ml-10">
                <div className=" font-semibold text-lg ">History</div>
                <div className=" ">{arr.length} Recipes</div>
              </div>
            </div>
          </div>
          {/* <div className=" flex flex-col items-center mt-5">
            {" "}
            <div className=" h-[100px] w-[88%] lg:w-[80%] rounded-xl  bg-white flex items-center">
              <div
                className={`w-[80px] h-[80px] rounded-full flex items-center justify-center ml-6 bg-[#8cd7aa]`}
              >
                <ShareIcon />
              </div>
              <div className="flex flex-col ml-10">
                <div className=" font-semibold text-lg ">Shared Recipes</div>
                <div className=" ">12 Recipes</div>
              </div>
            </div>
          </div> */}
          {/* <div
            onClick={() => {
              router.push(`/library/${user["id"]}`);
            }}
            className=" flex flex-col items-center mt-5"
          >
            {" "}
            <div className=" h-[100px] w-[88%] lg:w-[80%] rounded-xl  bg-white flex items-center">
              <div
                className={`w-[80px] h-[80px] rounded-full flex items-center justify-center ml-6 bg-[#85c5ff]`}
              >
                <HistoryIconBlue />
              </div>
              <div className="flex flex-col ml-10">
                <div className=" font-semibold text-lg ">
                  Uploaded Recipes 2
                </div>
                <div className=" ">{arr.length} Recipes</div>
              </div>
            </div>
          </div> */}
          <BottomNav />
        </section>
      </>
    );
  }
}
